"use strict";function getCloudCallList$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getCloudCallList$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.conference.getCloudCallList";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.0"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"6.0.9"},_a)),exports.getCloudCallList$=getCloudCallList$,exports.default=getCloudCallList$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/conference/getCloudCallList.js
// module id = 927
// module chunks = 106